// ============================================================
// SINGARAA - WhatsApp Integration
// ============================================================

export const WHATSAPP_NUMBER = '919106302759';

export const DEFAULT_MESSAGE = `Hello Singaraa Team,

I'm interested in ordering Singaraa Dry Roasted Peanuts.

Thank you.`;

/**
 * Generate a WhatsApp URL with a pre-filled message.
 * @param {string} message - The message to send.
 * @returns {string} WhatsApp URL.
 */
export function getWhatsAppUrl(message = DEFAULT_MESSAGE) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

/**
 * Build a formatted WhatsApp message for general inquiries.
 * @param {Object} formData - The contact form data.
 * @returns {string} Formatted WhatsApp message.
 */
export function buildContactMessage(formData) {
  const lines = [
    `*NEW INQUIRY - SINGARAA*`,
    `━━━━━━━━━━━━━━━━━━━━━`,
    `👤 *Name:* ${formData.name}`,
    `📞 *Phone:* ${formData.phone}`,
  ];
  if (formData.email) lines.push(`✉️ *Email:* ${formData.email}`);
  
  lines.push(`━━━━━━━━━━━━━━━━━━━━━`);
  lines.push(`💬 *Message:*`);
  lines.push(`${formData.message}`);

  return lines.join('\n');
}


/**
 * Build a formatted WhatsApp message for customer orders.
 * @param {Object} orderData - The order details.
 * @returns {string} Formatted WhatsApp order message.
 */
export function buildOrderMessage(orderData) {
  const lines = [
    `🥜 *NEW ORDER REQUEST - SINGARAA* 🥜`,
    `━━━━━━━━━━━━━━━━━━━━━`,
    `👤 *Customer:* ${orderData.name || 'Customer'}`,
    `📞 *Phone:* ${orderData.phone || 'Not provided'}`,
    `📍 *Address:* ${orderData.address || ''}`,
    `🏙️ *City & Pincode:* ${orderData.city || ''} ${orderData.pincode ? `- ${orderData.pincode}` : ''}`,
    `━━━━━━━━━━━━━━━━━━━━━`,
    `📦 *Order Details:*`,
    `• *Selected Pack:* ${orderData.packTitle || 'Singaraa Dry Roasted Peanuts'}`,
    `• *Total Weight:* ${orderData.totalWeight || '500g'}`,
    `• *Number of Orders:* ${orderData.quantity || 1}`,
  ];

  if (orderData.finalPrice) {
    if (orderData.normalPrice && orderData.normalPrice > orderData.finalPrice) {
      lines.push(`• *Normal MRP:* ~₹${orderData.normalPrice * (orderData.quantity || 1)}~`);
    }
    lines.push(`• *Final Price:* ₹${orderData.finalPrice * (orderData.quantity || 1)}`);
    if (orderData.totalSaving && orderData.totalSaving > 0) {
      lines.push(`• *Instant Savings:* ₹${orderData.totalSaving}`);
    }
  }

  lines.push(`• *Payment Mode:* ${orderData.paymentMethod || 'UPI'}`);

  if (orderData.notes && orderData.notes.trim()) {
    lines.push(`• *Special Note:* ${orderData.notes.trim()}`);
  }

  lines.push(`━━━━━━━━━━━━━━━━━━━━━`);
  lines.push(`Please confirm order confirmation, dispatch date, and payment QR code.`);
  lines.push(`Thank you!`);

  return lines.join('\n');
}
